import { useState, useMemo, FC } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { useIntl } from 'react-intl';

import { DisplayErrors } from '../../../../utils/DisplayErrors';
import { Portal } from '../../../../_metronic/partials';
import AhadDialog from '../../../../setup/shared/AhadDialog';
import { toast } from 'react-toastify';
import { serialize } from 'object-to-formdata';
import { $t } from '../../../../_metronic/i18n/formatMessage';
import { SaveCancelBtnsGroup } from '../../SaveCancelBtnsGroup';
import { KTSVG } from '../../../../_metronic/helpers';
import { axiosInstance } from '../../../../network/apis';
import { TextArea } from '../../textarea';

type Props = {
  id?: string | number | null;
  itemData?: any; // reports object
  title?: string;
  rejectItemObject?: any;
  setRejectItemObject?: Function;
  requestURI?: string;
  successMessage?: string;
  showButtonGroup?: boolean;
  afterSucessRequest?: Function;
};

export const RejectCompaniesDeletionRequests: FC<Props> = ({
  id,
  itemData,
  title,
  rejectItemObject,
  setRejectItemObject,
  requestURI,
  successMessage,
  showButtonGroup = false,
  afterSucessRequest,
}) => {
  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(false);

  const rejectDeletionRequest = async (values: any, resetForm: any, setSubmitting: any) => {
    if (!requestURI) return;
    setSubmitting(true);
    setLoading(true);
    try {
      const formData = serialize(values);
      await axiosInstance.post(requestURI, formData);
      successMessage && toast.success(formatMessage({ id: successMessage }) || '');
      setRejectItemObject && setRejectItemObject(null);
      afterSucessRequest && afterSucessRequest();
    } catch (error) {
      DisplayErrors(error);
    } finally {
      setSubmitting(false);
      setLoading(false);
      resetForm();
    }
  };

  const formik = useFormik({
    initialValues: {
      note: '',
    },
    validationSchema: useMemo(
      () =>
        Yup.object({
          note: Yup.string().nullable(),
        }).shape({}),
      []
    ),

    onSubmit: (values, { resetForm, setSubmitting }) =>
      rejectDeletionRequest(values, resetForm, setSubmitting),
  });

  return (
    <div>
      {rejectItemObject && rejectItemObject.id === id && (
        <Portal className='full_modal'>
          <AhadDialog
            titleId={title || 'Reject'}
            closeCallBack={() => {
              setRejectItemObject && setRejectItemObject(null);
            }}
            specialContainerClass='dialog-content w-600px'
          >
            <FormikProvider value={formik}>
              <Form id='create_template' noValidate autoComplete='none'>
                <div className='d-flex flex-column'>
                  <div>
                    <TextArea
                      placeholder={formatMessage({ id: 'Reason of rejection' })}
                      labelId={formatMessage({ id: 'Reason of rejection' })}
                      name={'note'}
                      type={'note'}
                      formik={formik}
                    />
                  </div>

                  {showButtonGroup && (
                    <SaveCancelBtnsGroup
                      saveBtnLabel='Reject'
                      formik={formik}
                      containerClassName='col-xl-6'
                      loading={loading}
                      cancelOnClick={() => {
                        setRejectItemObject && setRejectItemObject(null);
                      }}
                    />
                  )}
                </div>
              </Form>
            </FormikProvider>
          </AhadDialog>
        </Portal>
      )}

      <a
        className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
        title={$t('Reject')}
        onClick={() => setRejectItemObject && setRejectItemObject(itemData)}
      >
        <KTSVG path='/media/icons/duotune/general/gen034.svg' className='svg-icon-3' />
      </a>
    </div>
  );
};
